import React from "react";
import classNames from "classnames";
import { ArrowIcon } from "@shared/ui/Icon/ui/Common/arrow-icon";
import { menuItems } from "./config";
import { DesktopMenuProps } from "./types";
import classes from "./desktop-menu.module.scss";

export const DesktopMenu = ({ className, activeItem }: DesktopMenuProps) => {
    return (
        <nav className={classNames(classes["desktop-menu"], className)}>
            <ul className={classes["desktop-menu__list"]}>
                {menuItems.map(({ title, link, children }) => {
                    if (children) {
                        return (
                            <li key={title} className={classes["desktop-menu__item"]}>
                                <span
                                    className={classNames(
                                        classes["desktop-menu__link"],
                                        classes["desktop-menu__link-with-child"]
                                    )}
                                >
                                    {title}{" "}
                                    <span className={classes["desktop-menu__link-icon"]}>
                                        <ArrowIcon />
                                    </span>
                                </span>
                                <ul className={classes["desktop-menu__submenu"]}>
                                    {children.map(({ title: childTitle, externalLink }) => (
                                        <li
                                            key={childTitle}
                                            className={classes["desktop-menu__submenu-item"]}
                                        >
                                            <a
                                                href={externalLink}
                                                target="_blank"
                                                className={classNames(
                                                    classes["desktop-menu__link"],
                                                    {
                                                        [classes["desktop-menu__link--active"]]:
                                                            activeItem.link === externalLink
                                                    }
                                                )}
                                            >
                                                {childTitle}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        );
                    } else {
                        return (
                            <li key={link} className={classes["desktop-menu__item"]}>
                                <a
                                    href={link}
                                    className={classNames(classes["desktop-menu__link"], {
                                        [classes["desktop-menu__link--active"]]:
                                            activeItem.link === link
                                    })}
                                >
                                    {title}
                                </a>
                            </li>
                        );
                    }
                })}
            </ul>
        </nav>
    );
};